import {callLater} from "./playUtil.es6";
import stopEvent from "./stopEvent.es6";

function elementHasClickHandler(target) {
    if (!target || target.disabled) {
        return false;
    }
    if (target.onclick) {
        return true;
    }

    const jqEvents = $._data(target, "events");
    if (jqEvents && jqEvents.click) {
        return true;
    }

    // no click handler by default
    return false;
}

function eventKeeper() {
    return $('body');
}

let lastHandler = null;


export default class WaitUserAction {
    static cancel() {
        if (lastHandler === null) {
            return;
        }

        eventKeeper()
            .off('click touch keypress', lastHandler)
            .css('cursor', '');
        lastHandler = null;
    }

    static wait(callback) {
        WaitUserAction.cancel();

        const handler = e => {
            if ($(e.target).is('body') || !elementHasClickHandler(e.target)) {
                WaitUserAction.cancel();
                callback();
                return stopEvent(e);
            }
        };

        lastHandler = handler;

        callLater(() => {
            eventKeeper()
                .one('click touch keypress', handler)
                .css('cursor', 'pointer');
        });
    }
}
